import EditPrefillMenu from "components/CRM/EditPrefillMenu";
import useModule from "hooks/useModule";
import { useEffect, useState } from "react";
import { SelectPicker } from "rsuite";
import useAvailableActions from "./useAvailableActions";
import useReferencedAction from "./useReferencedAction";
import _ from "underscore";

const RecordUpdateFields = ({ action, setAction, actions }) => {
  const [sections, setSections] = useState([]);

  const { availableActions } = useAvailableActions({ actions });
  const { moduleAPIName } = useReferencedAction({ action, actions });
  const { module } = useModule(moduleAPIName);

  useEffect(() => {
    const dataObj = action?.DataToUpdate;

    if (!dataObj || !Object.keys(dataObj).length) return;

    setSections(
      Object.keys(dataObj).map((fieldAPIName) => {
        return { Field: fieldAPIName, Value: dataObj[fieldAPIName] };
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <h3>Select Workflow Action</h3>
      <SelectPicker
        preventOverflow
        data={availableActions}
        style={{ width: "100%" }}
        placeholder="Select Action"
        onChange={onReferencedActionChange}
        value={action?.ReferencedAction}
        labelKey={"Name"}
        valueKey={"id"}
        searchable={false}
        renderMenuItem={(_, item) => MenuItem(item)}
      />
      <hr />
      {action?.ReferencedAction && (
        <>
          <h4>Select Fields To Update</h4>
          <EditPrefillMenu
            module={module}
            prefillPairs={sections}
            onChange={handleSectionsUpdate}
            editOnly={true}
            disabledFields={["Tags"]}
            useObjectForm
          />
        </>
      )}
    </>
  );

  function handleSectionsUpdate(newSections) {
    setSections(newSections);

    const payload = {};

    newSections.forEach((s) => (payload[s.Field] = s.Value));

    setAction((prev) => ({ ...prev, DataToUpdate: payload }));
  }

  function getActionInfo(actionID) {
    const foundAction = _.findWhere(availableActions, { id: actionID });

    if (!foundAction) {
      return { Name: null, Description: null };
    } else {
      return {
        Name: `Update Fields in Action ${foundAction.Index} Records`,
        Description: `Using the records imported from Action ${foundAction.Index}, update provided fields`,
      };
    }
  }

  function onReferencedActionChange(newActionID) {
    const actionInfo = getActionInfo(newActionID);

    const payload = {
      ReferencedAction: newActionID,
      DataToUpdate: {},
      ...(actionInfo.Name && { Name: actionInfo.Name }),
      ...(actionInfo.Description && {
        Description: actionInfo.Description,
      }),
    };

    setAction((prev) => ({ ...prev, ...payload }));
    setSections([]);
  }

  function MenuItem(item) {
    return (
      <div style={{ maxWidth: 400 }}>
        <div style={{ fontSize: 15 }} className="text-dark font-weight-500">
          Action {item.Index}
        </div>
        <div style={{ fontSize: 12 }}>
          Update fields in all records modified in Action {item.Index}
        </div>
      </div>
    );
  }
};

export default RecordUpdateFields;
